import React from "react";
import styled from "styled-components";

import CloseIcon from "./icons/Close";
import EntityIcon from "./icons/Entity1";
import userImage from "../assets/images/HH-image.png";
import Button from "./IconButton";
import SendIcon from "../components/icons/Send";

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  height: 100vh;
  width: 100%;
  z-index: 99999;
  display: ${props => (props.open ? "flex" : "none")};
  justify-content: center;
  align-items: center;
  @media (max-width: 575px) {
    align-items: flex-start;
  }
`;

const TweetContainer = styled.div`
  box-shadow: 0px 3px 15px rgba(0, 0, 0, 0.3);
  border-radius: 25px;
  width: 550px;
  @media (min-width: 1800px) {
    width: 770px;
    height: fit-content;
  }
  @media (max-width: 575px) {
    width: 100%;
    height: 100%;
    border-radius: 0px;
  }
`;

const IconNTweet = styled.div`
  display: flex;
`;

const EntityTweetContainer = styled.div`
  background-color: ${props => props.theme.tweetBackground};
  transition: background-color ease 1s;
  display: flex;
  border-radius: 25px 25px 0 0;
  flex-direction: row-reverse;
  padding: 20px 50px 20px 20px;
  align-items: center;

  @media (min-width: 1800px) {
    height: 30.7%;

    padding: 40px 100px 25px 38.5px;
  }

  @media (max-width: 575px) {
    box-sizing: border-box;
    height: 50%;
    border-radius: 0;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-end;
    padding: 20px;
  }
`;

const EntityDetail = styled.div`
  width: 31%;
  margin-left: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: 575px) {
    flex-direction: row-reverse;
    width: 100%;
    margin-bottom: 20px;
    margin-left: 0;
  }
  @media (min-width: 1800px) {
    width: 35%;
  }
`;

const TweetContent = styled.div`
  width: 100%;
  flex-direction: column;
  text-align: right;
`;

const LogoCircle = styled.div`
  border-radius: 50%;
  width: 57px;
  height: 57px;
  background-color: ${props => props.theme.buttonSecondary};
  transition: background-color ease 1s;
  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: 575px) {
    width: 40px;
    height: 40px;
    margin-left: 15px;
  }

  @media (min-width: 1800px) {
    width: 80px;
    height: 80px;
  }
`;

const UserAvatar = styled.img`
  vertical-align: middle;
  width: 57px;
  height: 57px;
  border-radius: 50%;
  @media (max-width: 575px) {
    width: 40px;
    height: 40px;
    margin-left: 15px;
  }
  @media (min-width: 1800px) {
    width: 80px;
    height: 80px;
  }
`;

const EntityTitle = styled.div`
  font-size: 15px;
  font-family: "dubai-bold";
  color: ${props => props.theme.textHighlight};
  text-align: center;
  margin-top: 2.5px;
  line-height: 22px;

  @media (max-width: 575px) {
    color: ${props => props.theme.text};
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    width: 50%;
    text-align: right;
  }
  @media (min-width: 1800px) {
    font-size: 21px;
    margin-top: 10.5px;
  }
`;

const Date = styled.div`
  font-size: 12px;
  color: ${props => props.theme.textHighlight};
  opacity: 0.4;
  margin-bottom: 5px;
  @media (min-width: 1800px) {
    font-size: 21px;
    line-height: 30px;
  }

  @media (max-width: 575px) {
    display: none;
  }
`;
const MobileOnlyDate = styled.p`
  font-size: 9px;
  line-height: 15px;
  margin: 0;
  font-family: "dubai-regular";

  @media (min-width: 575px) {
    display: none;
  }
`;

const TweetText = styled.div`
  font-size: 15px;
  color: ${props => props.theme.textHighlight};
  line-height: 22px;
  @media (min-width: 1800px) {
    font-size: 21px;
    line-height: 31px;
  }
`;

const ReplyContainer = styled.div`
  background-color: ${props => props.theme.background};
  transition: background-color ease 1s;
  display: flex;
  border-radius: 0 0 25px 25px;
  flex-direction: column;
  padding: 7% 10% 3% 3%;
  @media (min-width: 1800px) {
    padding: 37.5px 100px 38.5px 80px;
  }
  @media (max-width: 575px) {
    box-sizing: border-box;
    height: 50%;
    border-radius: 0;
    flex-direction: column;
    justify-content: space-between;
    padding: 20px;
  }
`;

const ReplyContent = styled.div`
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  @media (max-width: 575px) {
    flex-direction: column;
  }
`;

const TextArea = styled.textarea`
  color: ${props => props.theme.textHighlight};
  direction: rtl;
  background: transparent;
  outline: none;
  border: none;
  width: 100%;
  min-height: 100px;
  font-size: 15px;
  line-height: 22px;
  text-align: right;
  @media (min-width: 1800px) {
    font-size: 21px;
    line-height: 36px;
    overflow-x: hidden;
    min-height: 150px;
  }
  @media (max-width: 575px) {
    padding: 0;
  }
`;

const SendButton = styled(Button)`
  width: 115px;
  height: 35.5px;
  float: left;

  @media (max-width: 575px) {
    height: 30px;
    width: 100px;
  }

  @media (min-width: 1800px) {
    height: 40px;
    width: 160px;
  }
`;

const StyledCloseIcon = styled(CloseIcon)`
  margin-right: 20px;
  @media (max-width: 575px) {
    display: none;
  }
  @media (min-width: 1800px) {
    margin-right: 40px;
  }
`;

const MobileOnlyTitleAndClose = styled.div`
  display: flex;
  align-items: flex-end;
  font-size: 18px;
  font-family: "dubai-bold";
  margin-bottom: 30px;
  color: ${props => props.theme.textHighlight};
  @media (min-width: 575px) {
    display: none;
  }
`;

const MobileClose = styled(CloseIcon)`
  margin-left: 33.2px;
`;

const TweetReply = ({ open, onClose }) => {
  return (
    <Overlay open={open}>
      <IconNTweet>
        <StyledCloseIcon big onClick={onClose} />
        <TweetContainer>
          <EntityTweetContainer>
            <MobileOnlyTitleAndClose>
              الرد علي تغريدة <MobileClose secondary thin onClick={onClose} />
            </MobileOnlyTitleAndClose>
            <EntityDetail>
              <LogoCircle>
                <EntityIcon />
              </LogoCircle>
              <EntityTitle>
                جهة حكومية
                <MobileOnlyDate>12.12.2018</MobileOnlyDate>
              </EntityTitle>
            </EntityDetail>
            <TweetContent>
              <Date>12.12.2018</Date>
              <TweetText>
                نتيجةً لتطبيق بعض مبادرات تحسين الخدمات تم رفع سعادة المتعاملين
                من 80% إلى 92%
              </TweetText>
            </TweetContent>
          </EntityTweetContainer>
          <ReplyContainer>
            <ReplyContent>
              <EntityDetail>
                <UserAvatar src={userImage} />
                <EntityTitle>
                  سمو الشيخ حمدان بن محمد بن راشد آل مكتوم
                  <MobileOnlyDate>12.12.2018</MobileOnlyDate>
                </EntityTitle>
              </EntityDetail>
              <TweetContent>
                <Date>12.12.2018</Date>
                <TextArea placeholder="اكتب ردك هنا" />
              </TweetContent>
            </ReplyContent>
            <SendButton secondary onClick={onClose}>
              <SendIcon />
            </SendButton>
          </ReplyContainer>
        </TweetContainer>
      </IconNTweet>
    </Overlay>
  );
};

export default TweetReply;
